module.exports = __webpack_public_path__ + "static/media/loyalty_rewards-dt-fr.62f6aa18.jpg";